var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnion = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 13,
  viewBox: "0 0 21 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.1641 1.41406L12.6045 8.97266L12.6221 8.99023L11.208 10.4043L7.20312 6.39941L1.41406 12.1895L0 10.7754L5.78906 4.98535L5.78613 4.98242L7.2002 3.56738L11.1904 7.55762L18.75 0L20.1641 1.41406Z",
  fill: "#7F7F7F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnion);
export { ForwardRef as ReactComponent };